import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-ds-f",
  "use": "n-icon-ds-f-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol viewBox=\"0 0 7 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-ds-f\">\n<path d=\"M0.325684 11H1.96631V6.57617H6.50732V5.19189H1.96631V1.84473H6.9248V0.431152H0.325684V11Z\" fill=\"#1C2428\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol